<div class="py-4 container-fluid disb-detail-page">
  <div class="disb-detail-topbar">
    <h4 class="disb-detail-title">ข้อมูลเอกสารส่งเบิก</h4>
    <button type="button" class="btn disb-detail-back" (click)="onBack()">
      กลับ
    </button>
  </div>

  @if (loading()) {
    <div class="disb-detail-card">
      <div class="disb-detail-card-body">
        <p class="disb-detail-muted">กำลังโหลดข้อมูล...</p>
      </div>
    </div>
  } @else if (notFound()) {
    <div class="disb-detail-card">
      <div class="disb-detail-card-body">
        <p class="disb-detail-muted">ไม่พบเอกสารส่งเบิก หรือไม่มีสิทธิ์เข้าถึงรายการนี้</p>
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="onBack()">กลับไปหน้ารายการ</button>
      </div>
    </div>
  } @else if (certification()) {
    <div class="disb-detail-card">
      <div class="disb-detail-card-body">
        <div class="disb-detail-header">
          <h5 class="disb-detail-teacher">{{ teacherName() }}</h5>
          <app-status-badge
            [tone]="statusDisplay().tone"
            [label]="statusDisplay().label"
            size="md"
          />
        </div>

        <div class="disb-detail-meta">
          <span>เทอมการศึกษา: {{ academicTermLabel() }}</span>
          <span>สาขาวิชา: {{ departmentName() }}</span>
          @if (isInternational()) {
            <span>อาจารย์ผู้สอน: {{ teacherListLabel() }}</span>
          }
        </div>

        @if (approvalTrack().length > 0) {
          <div class="disb-detail-stepper" aria-label="การตรวจสอบและรับรอง ระยะที่ 1">
            <h6>การตรวจสอบและรับรอง ระยะที่ 1</h6>
            <ol class="disb-detail-stepper-list">
              @for (entry of approvalTrack(); track entry.station) {
                <li class="disb-detail-stepper-item" [ngClass]="'disb-detail-stepper-' + entry.state">
                  <span class="disb-detail-stepper-role">{{ entry.role_label }}</span>
                  <span class="disb-detail-stepper-names">{{ stationPersonNames(entry) }}</span>
                  @if (entry.state === 'done' && entry.acted_at) {
                    <span class="disb-detail-stepper-date">ดำเนินการเมื่อ {{ formatDate(entry.acted_at) }}</span>
                  }
                  @if (entry.state === 'current') {
                    <span class="disb-detail-stepper-current-badge">รอดำเนินการ</span>
                  }
                </li>
              }
            </ol>
          </div>
        }

        @if (hasRoundSection()) {
          <div class="disb-detail-round" aria-label="การตรวจสอบและรับรอง ระยะที่ 2">
            <div class="disb-detail-round-head">
              <h6>การตรวจสอบและรับรอง ระยะที่ 2</h6>
            </div>
            <ol class="disb-detail-stepper-list">
              @for (step of roundSteps(); track step.key) {
                <li class="disb-detail-stepper-item" [ngClass]="'disb-detail-stepper-' + step.state">
                  <span class="disb-detail-stepper-role">{{ step.label }}</span>
                  @if (step.state === 'done' && step.actedAt) {
                    <span class="disb-detail-stepper-date">ดำเนินการเมื่อ {{ formatDate(step.actedAt) }}</span>
                  }
                  @if (step.state === 'current') {
                    <span class="disb-detail-stepper-current-badge">รอดำเนินการ</span>
                  }
                </li>
              }
            </ol>
          </div>
        }
      </div>
    </div>

    @if (documentsVisible()) {
      <div class="disb-detail-card">
        <div class="disb-detail-card-body">
          @for (section of documentSections(); track section.docType) {
            <div class="disb-detail-doc-section">
              <h6>{{ section.title }}</h6>

              @if (section.note !== null) {
                <p class="disb-detail-doc-empty">{{ section.note }}</p>
              } @else if (section.isEmpty) {
                <p class="disb-detail-doc-empty">ยังไม่มีเอกสาร</p>
              } @else {
                @for (docRow of section.rows; track docRow.key) {
                  <div class="disb-detail-doc-row">
                    <div class="disb-detail-doc-row-head">
                      <span class="disb-detail-doc-label">{{ docRow.label }}</span>
                      <div class="disb-detail-doc-buttons">
                        <button
                          type="button"
                          class="btn btn-secondary btn-sm disb-detail-doc-button"
                          (click)="onTogglePreview(docRow)"
                        >
                          {{ isPreviewExpanded(docRow.key) ? 'ซ่อนตัวอย่าง' : 'ดูตัวอย่าง' }}
                        </button>
                        @if (downloadsUnlocked()) {
                          <button
                            type="button"
                            class="btn btn-primary btn-sm disb-detail-doc-button"
                            [disabled]="isDownloadingDoc(docRow.key)"
                            (click)="onDownloadDocument(docRow)"
                          >
                            {{ isDownloadingDoc(docRow.key) ? 'กำลังดาวน์โหลด...' : 'ดาวน์โหลด' }}
                          </button>
                        }
                      </div>
                    </div>

                    @if (isPreviewExpanded(docRow.key)) {
                      <div class="disb-detail-doc-preview">
                        @if (isPreviewLoading(docRow.key)) {
                          <p class="disb-detail-doc-preview-loading">กำลังโหลดเอกสาร...</p>
                        } @else if (previewHasError(docRow.key)) {
                          <p class="disb-detail-doc-preview-error">{{ previewErrorMessage(docRow.key) }}</p>
                        } @else {
                          @if (previewUrl(docRow.key); as url) {
                            <iframe
                              class="disb-detail-doc-preview-frame"
                              [src]="url"
                              [title]="docRow.label"
                            ></iframe>
                          }
                        }
                      </div>
                    }
                  </div>
                }
              }
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="disb-detail-card">
        <div class="disb-detail-card-body">
          <p class="disb-detail-muted">
            เอกสารส่งเบิกจะพร้อมให้ดูตัวอย่างเมื่อผ่านการรับรองครบทุกขั้นตอนแล้ว (สถานะ "รอเข้ารอบส่งเบิก" ขึ้นไป) — ขณะนี้ยังอยู่ระหว่างการรับรอง
          </p>
        </div>
      </div>
    }
  }
</div>
